<template>
    <gofix-card title="attachments" class="attachmentGeneral">
        <template slot="gofixCard:right_header">
            <b-button class="icon-button pl-10" @click="openModelRemoveUpload" v-if="deleteRole && selected.length && setting.delete">
                <div class="tooltip">Delete</div>
                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0" />
                </svg>
            </b-button>
            <b-button class="icon-button pl-10" @click="openModelUpload" type="button" v-if="createRole && setting.create">
                <div class="tooltip">Create</div>
                <svg width="20" height="20" xmlns="http://w.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z" />
                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z" />
                </svg>
            </b-button>
            <b-button class="icon-button pl-10" @click="dowloadAttachments" v-if="selected.length && setting.download">
                <div class="tooltip">Download</div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#999999" />
                </svg>
            </b-button>
        </template>
        <viewer-image :images="Item.attachments" :showImage="true" classViewer='row attachmentGeneral attachmentsColumn align-items-center mt-10 pl-0'>
            <template slot="gofixViewer:list_image" slot-scope="{images}">
                <b-col class="col-5" v-for="attachment in images" v-bind:key="attachment.id">
                    <b-row class="align-items-center">
                        <b-col md="1" class="text-center">
                            <b-form-checkbox :value="attachment.id" v-model="selected" class="uniform pl-15 custom-control custom-checkbox"></b-form-checkbox>
                        </b-col>
                        <b-col md="10">
                            <div class="item-content bg-transparent pd-0">
                                <div class="w-100-percent d-flex align-items-center line-height-19 seclectPdf" v-if="attachment" @click="previewFile(attachment)">
                                    <b class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></b>
                                    <label class="text-hidden-ellipsis-two-row mb-0">{{ attachment.image_file_title || attachment.image_file_name }}</label>
                                    <button v-if="updateRole && setting.update" @click.stop="openModalupdateAttachment(attachment)" type="button" class="buttonAttachments">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.71 5.63126C21.1 6.02127 21.1 6.65127 20.71 7.04127L18.88 8.87126L15.13 5.12126L16.96 3.29126C17.1468 3.10401 17.4005 2.99878 17.665 2.99878C17.9295 2.99878 18.1832 3.10401 18.37 3.29126L20.71 5.63126ZM3 20.5013V17.4613C3 17.3213 3.05 17.2013 3.15 17.1013L14.06 6.19126L17.81 9.94127L6.89 20.8513C6.8 20.9513 6.67 21.0013 6.54 21.0013H3.5C3.22 21.0013 3 20.7813 3 20.5013Z" fill="#999999" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </template>
        </viewer-image>
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer>
            <b-form class="formV2">
                <gofix-form-input label="File Title" v-model="file_title"></gofix-form-input>
                <b-form-group :label="fileName">
                    <b-form-file ref="file-input" v-model="fileAttachment"></b-form-file>
                </b-form-group>
                <b-button-group class="text-right d-block">
                    <gofix-button v-if="Item.id" label="SUBMIT" @click="uploadAttachment" :loading="isUpload" noBorder></gofix-button>
                    <gofix-button v-else label="SUBMIT" @click="createAttachment" :loading="isUpload" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to Attachments" hide-footer hide-header :centered="true" ref="modal-Remove-Attachments">
            <div class="center">Are you sure you want to<br />delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$refs['modal-Remove-Attachments'].hide()">No</b-button>
                <b-button class="custom-btn" @click="removeAttachments" :disabled="isRemove">
                    <b-spinner v-if="isRemove" type="grow" small></b-spinner> Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments-edit" id="modal-Contract-Attachments" hide-footer>
            <b-form class="formV2">
                <gofix-form-input label="File Title" v-model="file_title"></gofix-form-input>
                <b-form-group :label="fileName">
                    <b-form-file ref="file-input" v-model="fileAttachment"></b-form-file>
                </b-form-group>
                <b-button-group class="text-right d-block">
                    <gofix-button label="SUBMIT" @click="updateAttachment" :loading="isUpload" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </gofix-card>
</template>
<script>
import { mapGetters } from 'vuex'
const ViewerImage = () => import('../plugins/ViewerImage.vue')
export default {
    name: 'attachment',
    props: {
        Item: {
            type: Object,
            default: {},
            attachments: {
                type: Array,
                default: []
            }
        },
        attachable_type: {
            type: String,
            default: null
        },
        controls: {
            type: Object,
            default: () => {}
        },
        createRole: {
            type: Boolean,
            default: true
        },
        updateRole: {
            type: Boolean,
            default: true
        },
        deleteRole: {
            type: Boolean,
            default: true
        },
    },
    components: {
        ViewerImage
    },
    data() {
        return {
            icons: {
                'application': {
                    'word': {
                        'img': 'word.png',
                        'svg': '<svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                    },
                    'excel': {
                        'img': 'excel.png',
                        'svg': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                    },
                    'pdf': {
                        'img': 'pdf.png',
                        'svg': '<svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                },
                'image': {
                    'img': 'image.png',
                    'svg': '<svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                },
                'text': {
                    'img': 'notepad.png',
                    'svg': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                },
                'inode': 'none'
            },
            file_title: '',
            fileAttachment: null,
            fileName: 'Click Browse to upload file',
            isUpload: false,
            isRemove: false,
            selected: [],
            setting: {
                create: true,
                update: true,
                delete: true,
                download: true
            }
        }
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
        }),
    },
    created() {
        this.setting = Object.assign(this.setting, this.controls);
    },
    filters: {
        iconFile(val, icons, is_svg = false) {
            let path = 'img/';
            let type_show = 'img';
            let extension = '';
            let type = val.type || val.image_content_type;

            if (is_svg) {
                path = '';
                type_show = 'svg';
            }
            if (val.type) extension = val.name.split('.')[1];

            let arrTemp = type.split('/');
            if (arrTemp && arrTemp.length == 2) {
                let type = arrTemp[0];
                if (!extension) extension = arrTemp[1];

                if (type == 'application' || type == 'inode' || type == 'text') {
                    let key = 'pdf';
                    if (['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                    if (['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                    if (['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {

                        let extension = val.image_file_name.split('.')[1];
                        if (['doc', 'docx'].includes(extension)) key = 'word';
                        if (['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';

                    }
                    return `${path}${icons['application'][key][type_show]}`;
                }

                return `${path}${icons[type][type_show]}`;
            }
        }
    },
    watch: {
        fileAttachment: function(val, old) {
            this.fileName = 'Click Browse to upload file';
            if (val) {
                let extensionAccept = ['csv', 'xls', 'xlsx', 'docx', 'doc', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip'];
                let extensionArray = val.name.split('.');
                let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                if (!extensionAccept.includes(extension)) {
                    this.$refs['file-input'].reset()
                    return this.$bvToast.toast('File format is incorrect. Please select a .csv, .xls, .xlsx, .docx, .doc, .pdf, .txt, .jpeg, .jpg, .png, .gif file!', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'warning',
                        solid: true
                    })
                }
                this.fileName = val.name
            }
        },
        controls: function(val) {
            this.setting = Object.assign(this.setting, val);
        }
    },
    methods: {
        async previewFile(attachment) {
            const link = document.createElement('a');
            var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
            
            if ( this.UserLogin.organization && this.UserLogin.organization.is_supplier ) {
                path = this.$router.resolve({name: 'Supplier Portal FilePreview', params: {file_id: attachment.id}}).href;
            }

            link.href = path;
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
        },
        checkShowImage(val) {
            if (!val) return false;
            let arrTemp = val.split('/');
            if (!arrTemp || arrTemp.length < 2 || arrTemp[0] != 'image') return false;
            return true;
        },
        checkShowIcon(val) {
            if (!val) return false;
            let arrTemp = val.split('/');
            if (!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
            return true;
        },
        openModelRemoveUpload() {
            this.isRemove = false
            this.$refs['modal-Remove-Attachments'].show();
        },
        openModelUpload() {
            this.isUpload = false
            this.fileName = 'Click Browse to upload file';
            this.file_title = null;
            this.fileAttachment = null;
            this.$refs['modal-Import-attachments'].show()
        },
        async dowloadAttachments() {
            let data = this.Item.attachments
            data.map(async (item, key) => {
                if (this.selected.includes(item.id)) {
                    // axios({
                    //     url: item.url.original,
                    //     method: 'GET',
                    //     responseType: 'blob',
                    //     headers: {
                    //         'Authorization': ''
                    //     } // important
                    // }).then((response) => {
                    //     const url = window.URL.createObjectURL(new Blob([response.data]));
                    //     const link = document.createElement('a');
                    //     link.href = url;
                    //     link.setAttribute('download', item.image_file_name);
                    //     document.body.appendChild(link);
                    //     link.click();
                    // });
                    let url = item.url.original;
                    let params = {};
                    params.url = url;
                    params.image_file_name = item.image_file_name;

                    await this.$store.dispatch("FileDownloadController/getFile", params)
                    .then(response => {
                    })
                    .catch(err => {
                        this.$alertNotification("Can not download file", "danger");
                        console.log(err);
                    });
                }
            })
            return this.$bvToast.toast("Download Attachment Successfully!", {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'success',
                solid: true
            })
        },
        openModalupdateAttachment(item) {
            this.isUpload = false
            let attachment = {
                fileName: item.image_file_name,
                attachment_id: item.id
            }
            this.fileName = item.image_file_name
            this.file_title = item.image_file_title
            this.attachment = JSON.parse(JSON.stringify(attachment))
            this.$refs['modal-Import-attachments-edit'].show();
        },
        uploadAttachment() {
            if (!this.fileAttachment) {
                return this.$bvToast.toast("Please select a file", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            };
            this.isUpload = true
            this.$store.dispatch('AttachmentController/uploadAttachment', {
                    id: this.Item.id,
                    attachment: this.fileAttachment,
                    type: this.attachable_type,
                    file_title: this.file_title
                })
                .then(result => {
                    this.$refs['modal-Import-attachments'].hide()
                    this.Item.attachments = result.data.data.attachments
                    return this.$bvToast.toast(this.$notificationV2('editing', 'attachment'), {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    })
                })
        },
        createAttachment() {
            if (!this.fileAttachment) {
                return this.$bvToast.toast("Please select a file", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            };
            this.isUpload = true
            this.$store.dispatch('AttachmentController/createAttachment', {
                    attachment: this.fileAttachment,
                })
                .then(result => {
                    this.$refs['modal-Import-attachments'].hide()
                    if (result.data.data.items.length > 0) {
                        this.Item.ids_attachment = result.data.data.items.map(item => item.id);
                        this.Item.attachments.push(result.data.data.items[0])
                    }
                    return this.$bvToast.toast(this.$notificationV2('adding', 'attachment'), {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    })
                })
        },
        removeAttachments() {
            this.isRemove = true
            this.$store.dispatch('AttachmentController/removeAttachments', {
                    ids: this.selected
                })
                .then(async result => {
                    this.Item.attachments = this.Item.attachments.filter(x => {
                        return this.selected.indexOf(x.id) === -1
                    })
                    this.selected = [];
                    this.$refs['modal-Remove-Attachments'].hide()
                    return this.$bvToast.toast(this.$notificationV2('deleting', 'attachment'), {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    })
                })
        },
        updateAttachment() {
            if (this.fileName == 'Click Browse to upload file' && !this.fileAttachment) {
                return this.$bvToast.toast("Please select a file", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            };
            this.isUpload = true
            let request = {
                id: this.attachment.attachment_id,
                file_title: this.file_title
            }
            if (this.fileAttachment) request.attachment = this.fileAttachment
            this.$store.dispatch('AttachmentController/updateAttachments', request)
                .then(result => {
                    this.isUpload = false
                    let items = []
                    //re-assign item
                    this.Item.attachments.forEach(x => {
                        if (x.id != result.data.data.id) {
                            items.push(x)
                        } else {
                            items.push(result.data.data)
                        }
                    })
                    this.Item.attachments = items

                    this.$refs['modal-Import-attachments-edit'].hide();
                    return this.$bvToast.toast(this.$notificationV2('editing', 'attachment'), {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    })
                })
        }

    }
}
</script>